import React, { useState, useEffect } from "react";
import { getLessonTemplates, deleteLessonTemplate } from "../../api/Api";
import { showToast } from "../../utils/toastUtils";
import AddUpdateLessonTemplateModal from "./AddUpdateLessonTemplateModal";
import SelectTemplateModalUI from "./SelectTemplateModalUI";

const SelectLessonTemplateModal = ({ show, handleClose, handleUse }) => {
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [templateToEdit, setTemplateToEdit] = useState(null);

  // Fetch lesson templates from API on component mount
  useEffect(() => {
    const fetchTemplates = async () => {
      const data = await getLessonTemplates();
      if (data.status === 200) {
        setTemplates(data.data);
      } else {
        showToast("Failed to fetch lesson templates", "error");
      }
    };
    fetchTemplates();
  }, []);

  // Function to refresh the list of templates after a change
  const refreshTemplates = async () => {
    const data = await getLessonTemplates();
    if (data.status === 200) {
      setTemplates(data.data); 
    } else {
      showToast("Failed to refresh lesson templates", "error");
    }
  };

  // Handler to add a new template
  const handleAddNewTemplate = () => {
    setTemplateToEdit(null); 
    setShowModal(true);
  };

  // Handler to edit an existing template
  const handleEditTemplate = (template) => {
    setTemplateToEdit(template); 
    setShowModal(true);
  };

  // Handler to delete a template
  const handleDelete = async (template_id) => {
    try {
      const response = await deleteLessonTemplate(template_id);
      if (response.status === 200) {
        setTemplates(templates.filter((template) => template.id !== template_id));
        showToast("Lesson template deleted successfully", "success");
      } else {
        showToast("Failed to delete lesson template", "error");
      }
    } catch (error) {
      showToast("Error deleting lesson template", "error");
      console.error("Error deleting lesson template:", error);
    }
  };

  return (
    <>
      {/* Template selection modal */}
      <SelectTemplateModalUI
        show={show}
        handleClose={handleClose}
        title="Select a Template"
        items={templates}
        selectedItem={selectedTemplate}
        setSelectedItem={setSelectedTemplate}
        handleEdit={handleEditTemplate}
        handleDelete={handleDelete}
        handleAddNew={handleAddNewTemplate}
        handleUse={handleUse}
      />

      {/* Add or edit template modal */}
      {showModal && (
        <AddUpdateLessonTemplateModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          refresh={refreshTemplates} 
          template={templateToEdit}
        />
      )}
    </>
  );
};

export default SelectLessonTemplateModal;
